import React from 'react';
import { motion } from 'framer-motion';
import { Search, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import dashboardImg from '../../assets/osint/SecurityDashboard.png';

const OSINTHero = () => {
  const navigate = useNavigate();

  const features = [
    'Emails exposes',
    'Profils LinkedIn publics',
    'Fuites de donnees',
    'Domaines mal configures',
    'Avis Google negatifs',
    'Donnees trouvables via Google',
  ];

  const slateNavy = '#1E3A5F';
  const brightBlue = '#3b82f6';

  const springTransition = {
    type: 'spring',
    stiffness: 100,
    damping: 20,
    mass: 1,
  };

  return (
    <section
      className="relative w-full bg-white flex justify-center"
      style={{ minHeight: 'calc(100vh - 64px)', paddingTop: '80px', paddingBottom: '80px', overflow: 'hidden' }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 70% 40%, rgba(59,130,246,0.06) 0%, transparent 65%), radial-gradient(circle at 10% 80%, rgba(30,58,95,0.04) 0%, transparent 55%)',
        }}
      />

      <div className="relative z-10 max-w-[1100px] w-full px-6 flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-16">
        <div className="flex-1 max-w-[500px]">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springTransition, delay: 0.1 }}
            className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full mb-5"
            style={{ background: 'rgba(59,130,246,0.08)', border: '1px solid rgba(59,130,246,0.18)' }}
          >
            <Search size={10} color={brightBlue} />
            <span style={{ color: brightBlue, fontSize: '10px', fontWeight: 700, textTransform: 'uppercase' }}>
              Intelligence Numerique
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springTransition, delay: 0.2 }}
            style={{ fontSize: 'clamp(32px, 3.8vw, 46px)', fontWeight: 900, lineHeight: 1.0, letterSpacing: '-0.02em', marginBottom: '18px' }}
          >
            <span style={{ color: '#000000' }}>Services</span> <br />
            <span style={{ color: slateNavy }}>OSINT / Audits</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springTransition, delay: 0.3 }}
            style={{ color: 'rgba(30,58,95,0.6)', fontSize: '14px', lineHeight: 1.5, marginBottom: '22px', maxWidth: '380px' }}
          >
            collecte et analyse d&apos;informations publiques disponibles sur internet.
          </motion.p>

          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px 0' }}>
            {features.map((item, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4 + i * 0.05 }}
                style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#475569', fontSize: '13px', fontWeight: 700, marginBottom: '6px' }}
              >
                <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: brightBlue }} />
                {item}
              </motion.li>
            ))}
          </ul>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springTransition, delay: 0.7 }}
            className="flex flex-wrap gap-4"
          >
            <button
              onClick={() => navigate('/rdv')}
              className="px-6 lg:px-7 py-3 lg:py-3.5 rounded-xl font-bold text-[13px] transition-all duration-300 shadow-[0_10px_20px_rgba(30,58,95,0.3)] hover:scale-105"
              style={{ backgroundColor: slateNavy, color: 'white' }}
            >
              Demander un audit OSINT
            </button>

          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ ...springTransition, delay: 0.4 }}
          className="flex-1 flex justify-center lg:justify-end relative"
        >
          <div style={{ position: 'relative', padding: '18px', background: 'rgba(59,130,246,0.05)', borderRadius: '28px', border: '1px solid rgba(59,130,246,0.12)' }}>
            <img
              src={dashboardImg}
              alt="OSINT Dashboard"
              style={{ width: '100%', maxWidth: '400px', borderRadius: '18px', boxShadow: '0 20px 60px rgba(30,58,95,0.2)' }}
            />

            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{
                opacity: 1,
                x: 0,
                y: [0, -8, 0],
              }}
              transition={{
                opacity: { delay: 0.8 },
                x: { delay: 0.8, ...springTransition },
                y: { repeat: Infinity, duration: 4, ease: 'easeInOut' },
              }}
              style={{
                position: 'absolute',
                bottom: '-15px',
                left: '-20px',
                background: '#ffffff',
                padding: '12px 18px',
                borderRadius: '16px',
                boxShadow: '0 10px 30px rgba(30,58,95,0.15)',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                zIndex: 60,
                border: '1px solid #f1f5f9',
              }}
            >
              <div style={{ background: '#dcfce7', padding: '8px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ShieldCheck size={18} color="#16a34a" />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: '#94a3b8', fontSize: '8px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  Statut
                </span>
                <span style={{ color: slateNavy, fontWeight: 900, fontSize: '12px' }}>Protection Active</span>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default OSINTHero;
